import { withFormik } from 'formik';
import * as yup from 'yup';
import BloodSugarForm from './BloodSugarForm';
import { postBloodSugar, editBloodSugar } from '../../../services';
import { toast } from 'react-toastify';

const validationSchema = yup.object().shape({
  date: yup.date("Please enter date").required(),
  lab: yup.string().required(),
  urineSugarF: yup.number().required(),
  urineSugarPP: yup.number().required(),
  hb: yup.number().required(),
  preBloodSugar: yup.number().required(),
  postBloodSugar: yup.number().required(),
  title: yup.string().required(),
  description: yup.string().required()
})

const EnhancedBloodSugar = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    console.log(props);
    return {
      recordId: props.recordId,
      date: props.date,
      lab: props.lab,
      urineSugarF: props.urineSugarF,
      urineSugarPP: props.urineSugarPP,
      hb: props.hb,
      preBloodSugar: props.preBloodSugar,
      postBloodSugar: props.postBloodSugar,
      title: props.title,
      description: props.description,
      files: [],
      filesList: props.files,
      formType: props.formType,
      redirect: false
    }

  },
  mapPropsToStatus: (props) => {
    return {
      uploadedFiles: props.files
    }
  },
  handleSubmit: async (values, { resetForm, setSubmitting, props }) => {
    
    let formData = new FormData();
    
    for(let file of values.files) {
      formData.append("files", file);
    }

    formData.append("data", JSON.stringify(values))

    if(values.formType === "edit") {
      let response = await editBloodSugar(formData);
      toast.success("Record updated successfully");
      props.history.push("/personalhealthrecord/pregnancyvitals")
      return;

    } else {
      const response = await postBloodSugar(formData);
      resetForm()
      setSubmitting(false);
      toast.success("Record added successfully");
      if(values.redirect == true) {
        props.history.push("/personalhealthrecord/pregnancyvitals")    
      } else {
        props.handleNewRecord(response.data.record);
      }
    }
  },
  validationSchema: validationSchema

})(BloodSugarForm);

EnhancedBloodSugar.defaultProps = {
  date: null,
  lab: '',
  urineSugarF: '',
  urineSugarPP: '',
  hb: '',
  prebloodSugar: '',
  postBloodSugar: '',
  title: '',
  description: '',
  files: [],
  formType: 'add'
}

export default EnhancedBloodSugar;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/PregnancyVitals/PregnancyVitalsView/EnhancedBloodSugar.js